import { render, staticRenderFns } from "./EditSongChordsModal.vue?vue&type=template&id=4c7b2ec9&scoped=true"
import script from "./EditSongChordsModal.vue?vue&type=script&lang=ts"
export * from "./EditSongChordsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b2ec9",
  null
  
)

export default component.exports